
import React, { useEffect } from 'react';

import { exposiciones } from '../../json/exposiciones';
import './museo.css';

const Museo = () => {




    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container museo-container'>
            <div className='row'>
                <div>
                    <h3 className='title'>Exposiciones Fotográficas y Documentales</h3>
                    <hr className='hr-gob' />
                </div>
            </div>
            <div className="list-group">
                <a className="list-group-item list-group-item-action flex-column align-items-start ">
                    <div className="d-flex w-100 justify-content-between">
                        <div className='museo_item'>
                            <h5  >Descripción</h5>
                        </div>
                    </div>
                    <p >Exposiciones vigentes en la sala Fernando Gamboa</p>
                </a>

                <a className="list-group-item list-group-item-action flex-column align-items-start ">
                    <div className="d-flex w-100 justify-content-between">
                        <div className='museo_item'>

                            <div className='row'>
                                {

                                    exposiciones.map((item, index) => (
                                        <div key={index} className='col-md-4 col-sm-4 col-4'>
                                            <div classname='card_container_historicos_museo'>
                                                <div className='card_museo'>
                                                    <img src={"/assets/imgs/" + item.icono} class='card-img-top' alt='' />
                                                    <br></br>
                                                    <h4>{item.nombre}</h4>
                                                    <h6>{item.descripcion}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                        </div>
                    </div>

                </a>
                <a className='list-group-item list-group-item-action flex-column align-items-start'>
                    <div className='d-flex w-100 justify-content-between'>
                        <div className='museo_item'>
                            <h5 >Costo</h5>
                        </div>
                    </div>
                    <p >Gratuito
                    </p>
                </a>
                <a className='list-group-item list-group-item-action flex-column align-items-start'>
                    <div className='d-flex w-100 justify-content-between'>
                        <div className='museo_item'>
                            <h5 >Área de atención</h5>
                        </div>
                    </div>
                    <p >Archivo Histórico del Poder Ejecutivo<br></br>
                        Calle Hidalgo No. 807<br></br>
                        Col. Centro, C.P. 42000<br></br>
                        Pachuca de Soto, Hgo.<br></br>
                        Teléfono: (771) 71 7-60-00 Ext. 2381</p>
                </a>
                <a className='list-group-item list-group-item-action flex-column align-items-start'>
                    <div className='d-flex w-100 justify-content-between'>
                        <div className='museo_item'>
                            <h5 >Horario</h5>
                        </div>
                    </div>
                    <p >Lunes a Viernes de 09:00 a 16:00 hrs.</p>
                </a>
            </div>
        </div>
    )
}



export default Museo